<template>
  <div class="c-vertical-name" :ref="customRef" v-view.reveal="{ handler: viewParallax }">
    <div class="c-vertical-name__inner">
      <ul class="c-vertical-name__inner__list">
        <entrepreneur-vertical-name-list
          :first-name="firstName"
          :last-name="lastName"
          :style="this.animateText(false, 0, 100)"
        />
        <entrepreneur-vertical-name-list
          :first-name="firstName"
          :last-name="lastName"
          :style="this.animateText(true, 10, 100)"
        />
      </ul>
    </div>
  </div>
</template>

<script>
import Variables from "src/mixins/variables";
import EntrepreneurVerticalNameList from "components/EntrepreneurVerticalName/EntrepreneurVerticalNameList";
export default {
  components: {
    EntrepreneurVerticalNameList
  },
  props: {
    firstName: {
      type: String,
      required: true
    },
    lastName: {
      type: String,
      required: true
    }
  },
  mixins: [Variables],

  created() {
    window.addEventListener("resize", this.onResize);
  },
  destroyed() {
    window.removeEventListener("resize", this.onResize);
  },
  mounted() {
    this.onResize();
  },
  data() {
    return {
      animationPosition: {
        x: 0,
        y: 0
      },
      isMobile: false
    };
  },
  computed: {
    customRef() {
      return `verticalName${this.lastName}`;
    }
  },
  methods: {
    viewParallax(e) {
      return this.isMobile
        ? ((this.animationPosition.y = e.percent.top), (this.animationPosition.x = 0))
        : ((this.animationPosition.x = e.percent.left), (this.animationPosition.y = 0));
    },
    animateText(direction, start, index) {
      return this.isMobile
        ? `transform:translate(${this.isAnimationReverse(direction)}${start + this.animationPosition.y * index}px)`
        : `transform:translate( ${this.isAnimationReverse(direction)}${start + this.animationPosition.x * index}px)`;
    },
    isAnimationReverse(direction) {
      return direction ? "-" : "+";
    },

    ////////////////////////////////
    //       START MANAGE RESIZE
    ////////////////////////////////

    onResize() {
      this.setUserMobile();
      this.resetParalax();
    },
    setUserMobile() {
      //   return (this.isMobile = window.innerWidth < 1284 && window.innerHeight < 600);
      return (this.isMobile = window.innerWidth < 1284 || window.innerHeight < 600);
      //   $breakpoint-horizontal say 768px width. Maybe I need to step back and think but when I test the breakpoint is 1284 instead
    },

    resetParalax() {
      this.animationPosition.y = 0;
      this.animationPosition.x = 0;
    }
    ////////////////////////////////
    //       END MANAGE RESIZE
    ////////////////////////////////
  }
};
</script>

<style lang="scss" scoped>
.c-vertical-name {
  display: flex;
  /* no padding at the top and the bottom */
  overflow: hidden;
  max-width: 100vw;

  padding: var(--grid-gutter-double) 0px;

  @media #{$breakpoint-horizontal} {
    padding: 0px var(--grid-gutter-double) 0px $section-xl-padding-left;
    max-width: calc(200em + var(--grid-gutter-double));
    height: 100%;
  }

  &__inner {
    position: relative;
    &__list {
      @include reset-list;
      display: flex;
      flex-direction: column;
      @include transform(translate(-100vw, 0px));
      @media #{$breakpoint-horizontal} {
        @include transform(rotate(-90deg) translate(-250vh, 0px));
        max-width: 150px;
        transform-origin: 0% 0%;
      }
    }
  }
}
</style>
